import React from 'react';

import './index.scss';
import logoSP from 'assets/caregiver-jobma-sp.png';

import SpProgress from 'components/molecules/SpProgress';
import { PROGRESS_LIST } from 'utils/constant';

const getStatus = (idx, nowStep) => {
  if(idx === nowStep) return 'doing';
  if(idx > nowStep) return 'todo';
  return 'done';
};

const SpHeader = ({ step, selects = [], lpMode }) => (
  <div className="SpHeader">
    {!lpMode && (
      <div className="imageArea">
        <img className="logoJobma" src={logoSP} alt="logoSp" />
      </div>
    )}
    <div className="wrapper">
      <div className="progress">
        {PROGRESS_LIST.map((progress, idx) => {
          const { pStep, pTitleSp } = progress;
          const status = getStatus(idx, Number(step));
          return (
            <SpProgress
              key={pStep}
              status={status}
              step={pStep}
              titles={pTitleSp}
              hasBar={status !== 'todo' && idx !== 0}
              selects={selects[pStep]}
            />
          );
        })}
      </div>
    </div>
  </div>
);

export default SpHeader;
